import { AccountantInit } from '../classes/AccountantInit';
import { AdminInit } from '../classes/AdminInit';
import { AffiliateInit } from '../classes/AffiliateInit';
import { CustomerInit } from '../classes/CustomerInit';
import { PartnerInit } from '../classes/PartnerInit';
import { UserInitMap } from '../types/UserInitMap';

export const userInitMap: UserInitMap = {
  admin: () => new AdminInit(),
  customer: () => new CustomerInit(),
  partner: () => new PartnerInit(),
  accountant: () => new AccountantInit(),
  affiliate: () => new AffiliateInit()
};
